/*
 *
 * !!! DO NOT MODIFY DIRECTLY !!!
 *
 * @generated via scripts/import-icons
 *
 */

import React from 'react'

import { CssVars } from '../../../themes'
import { TextColorOverride } from '../../TextColorOverride'

export function History16({
  color,
}: {
  color?: React.ComponentProps<typeof TextColorOverride>['color']
}) {
  const node = (
    <svg
      fill="none"
      height="16"
      role="img"
      viewBox="0 0 16 16"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M7.333 4.667h1.334v3.057l1.804 1.805-.942.942-2.196-2.195v-3.61Z"
        fill={CssVars.textColor}
        fillRule="evenodd"
      />
      <path
        d="M8 2.667c2.933 0 5.333 2.4 5.333 5.333 0 2.933-2.4 5.333-5.333 5.333-2.708 0-4.961-2.045-5.292-4.666H1.366c.338 3.357 3.192 6 6.634 6 3.666 0 6.666-3 6.666-6.667s-3-6.667-6.666-6.667a6.657 6.657 0 0 0-5.03 2.304L1.333 2v4.333h4.334L3.914 4.581A5.328 5.328 0 0 1 8 2.667Z"
        fill={CssVars.textColor}
      />
    </svg>
  )
  return color ? (
    <TextColorOverride color={color}>
      {({ rootClassName }) => (
        // NOTE(jare): Since the svg node's display is "inline", it can be
        // rendered with a little whitespace around it in certain cases. We
        // wrap it in a flexbox container to remove that whitespace.
        <span className={rootClassName} css={{ display: 'inline-flex' }}>
          {node}
        </span>
      )}
    </TextColorOverride>
  ) : (
    node
  )
}
